import { Route } from '../../../../domain/route/Route';
import { NotificationActionType, NotificationActions } from './actions';

export type Notification = {
  id:
    | `smartmonkey.planner.2.planner.stop.deleted`
    | `smartmonkey.planner.2.planner.stop.created`
    | `smartmonkey.planner.2.planner.stop.rescheduled`
    | `smartmonkey.planner.2.planner.stop.moved`
    | `smartmonkey.planner.2.planner.stop.reported`
    | `smartmonkey.planner.2.planner.stop.updated`
    | `smartmonkey.planner.2.planner.driver.deleted`
    | `smartmonkey.planner.2.optimizer.find_new_route_optimization.succeeded`;
  data: Route | any;
};

export interface NotificationState {
  notification?: Notification;
}

export const getInitialState = (): NotificationState => ({
  notification: undefined,
});

export const NotificationReducer = (state: NotificationState, action: NotificationActions): NotificationState => {
  switch (action.type) {
    case NotificationActionType.SET_NOTIFICATION:
      return {
        ...state,
        notification: action.payload,
      };
    default:
      return state;
  }
};
